import { ReactComponent as DashboardIcon } from 'assets/icons/menu/dashboard.svg';
import { ReactComponent as ModulesIcon } from 'assets/icons/menu/modulos.svg';
import { ReactComponent as AnalyticalReportIcon } from 'assets/icons/menu/relatorio-analitico.svg';
import { IAppRoute } from 'interfaces/route';
import { userRoles } from 'interfaces/user';
import { PureComponent } from 'react';

import CategoryRouter from './categoryRoutes';
import AnalyticalReport from './Report/Analytical';
import Adherence from './Dashboard/View/Adherence';
import DashboardRouter from './dashboardRouter';

export default class DocumentationRouter extends PureComponent {
  public static routes: IAppRoute[] = [
    {
      path: '/dashboard',
      roles: [
        userRoles.sysAdmin,
        userRoles.admin,
        userRoles.auditor,
        userRoles.holding,
        userRoles.venturer,
        userRoles.operator,
      ],
      isProfileSelectedDependent: true,
      component: DashboardRouter,
    },
    {
      path: '/adherence',
      sideDrawer: {
        display: 'Dashboard',
        order: 1,
        icon: DashboardIcon,
        href: '/documentation/adherence?snapshotId=0',
      },
      roles: [
        userRoles.sysAdmin,
        userRoles.admin,
        userRoles.auditor,
        userRoles.holding,
        userRoles.venturer,
        userRoles.operator,
      ],
      isProfileSelectedDependent: true,
      component: Adherence,
    },
    {
      path: '/files',
      sideDrawer: { display: 'Módulos', order: 2, icon: ModulesIcon },
      isProfileSelectedDependent: true,
      roles: [
        userRoles.admin,
        userRoles.auditor,
        userRoles.holding,
        userRoles.venturer,
        userRoles.operator,
        userRoles.visitor,
        userRoles.third,
      ],
      subMenuDefault: 'open',
      component: CategoryRouter,
    },

    {
      path: '/analytical',
      sideDrawer: {
        display: 'Relatório Analítico',
        order: 3,
        icon: AnalyticalReportIcon,
      },
      roles: [
        userRoles.admin,
        userRoles.auditor,
        userRoles.holding,
        userRoles.venturer,
        userRoles.operator,
      ],
      component: AnalyticalReport,
    },
  ];

  render() {
    return this.props.children;
  }
}
